import { render, staticRenderFns } from "./AvatarEditable.vue?vue&type=template&id=4132a4f4&scoped=true&lang=pug&"
import script from "./AvatarEditable.vue?vue&type=script&lang=js&"
export * from "./AvatarEditable.vue?vue&type=script&lang=js&"
import style0 from "./AvatarEditable.vue?vue&type=style&index=0&id=4132a4f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4132a4f4",
  null
  
)

export default component.exports